/* assets/price-fetch.js.liquid */

function sanitizeId(str) {
  return String(str).replace(/\D/g, '');
}

function runSweepstakesFetch(cardEl) {
  const productId     = `gid://shopify/Product/${cardEl.dataset.productId}`;
  const platformId    = `gid://shopify/Shop/${cardEl.dataset.shopGid}`;
  const subtotal      = parseFloat(cardEl.dataset.subtotal);
  const sweepstakeId  = sanitizeId(cardEl.dataset.sweepstakeId) || 'default';

  const query = `
    query QuerySweepstakeDetailsByProductId(
      $platform: String!
      $platformId: String!
      $productIds: [String!]
    ) {
      sweepstakeDetailsByProductId(
        platform: $platform
        platformId: $platformId
        productIds: $productIds
      ) {
        id
        entryManagement
        productsAllowedByDefault
        bonusEntriesDefault
        isActive
        products(productIds: $productIds) {
          productId
          productAllowed
          productBonusEntries
          productMultiplier
        }
      }
    }
  `;

  const variables = {
    platform:   'Shopify',
    platformId: platformId,
    productIds: [productId],
  };

  (async () => {
    try {
        const res = await fetch('https://backend.cleansweeps.app/graphql', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, variables }),
        });

        if (!res.ok) throw new Error(`Network error: ${res.status}`);

        const json = await res.json();

        if (json.errors && json.errors.length) {
        console.error('GraphQL errors:', json.errors);
        return;                                        // bail early
        }

        const details = json.data?.sweepstakeDetailsByProductId;
        if (!details || !details.length) return;

        let matched = details.find(d => sanitizeId(d.id) === sweepstakeId)
                || details.find(d => d.isActive)
                || details[0];
        if (!matched) return;

        /* ---------- calculations ---------- */
        const entryMgmt   = JSON.parse(matched.entryManagement);
        const dollarSpent = parseFloat(entryMgmt.dollarSpent);
        const entriesPer  = parseFloat(entryMgmt.entryPer);
        const roundUp     = entryMgmt.roundUp ?? true;
        const roundFn     = roundUp ? Math.ceil : Math.floor;

        let finalMultiplier = entriesPer;
        let finalEntries;

        if ((!matched.products || !matched.products.length) && matched.productsAllowedByDefault) {
          finalEntries =
              roundFn((entriesPer / dollarSpent) * roundFn(subtotal)) +
              matched.bonusEntriesDefault;
        } else {
          const prod = matched.products?.[0];
          if (!prod || !prod.productAllowed) {
              finalEntries = 'Product Not Eligible';
          } else {
              const prodMult = parseFloat(prod.productMultiplier);
              finalEntries =
                roundFn((entriesPer / dollarSpent) * roundFn(subtotal) * prodMult) +
                prod.productBonusEntries;
              // expedition did not want the builtin multipliers to be shown in the final
              finalMultiplier = roundFn(entriesPer);
          }
        }

        /* ---------- DOM updates ---------- */
        const multiplierBox = cardEl.querySelector(
        `#flash-text-dynamic-${cardEl.dataset.productId}`
        );
        if (multiplierBox && finalMultiplier > 1) {
        multiplierBox.classList.remove('hidden');
        multiplierBox.textContent = `${finalMultiplier}X`;
        }

        const entriesBox = cardEl.querySelector(
        `#entries-text-placeholder-thumb-${cardEl.dataset.productId}-${sweepstakeId}`
        );
        if (!entriesBox) return;

        if (typeof finalEntries === 'number') finalEntries = String(finalEntries);
        entriesBox.textContent =
        finalEntries === 'Product Not Eligible'
            ? finalEntries
            : `${finalEntries} Entries`;
    } catch (err) {
        console.error('Sweepstake fetch error:', err);
    }
  })();
}

function initOneCard(el) {
  if (el.__priceCardInit) return;         // idempotent
  el.__priceCardInit = true;
  runSweepstakesFetch(el);
}


function scan(root = document) {
  root
    .querySelectorAll('[data-price-context="card"]')
    .forEach(initOneCard);
}

document.addEventListener('DOMContentLoaded', () => scan());
document.addEventListener('shopify:section:load', (e) => scan(e.target));
const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    m.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.('[data-price-context="card"]')) initOneCard(node);
      if (node.querySelector) scan(node);
    });
  }
});
observer.observe(document.documentElement, {
  childList: true,
  subtree:   true,
});